module.exports = __webpack_public_path__ + "af2f2080e4f18a274f392571dc38ca8d.png";